import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Beslut } from '../../interfaces/beslut.interface';

@Injectable()
export class ArbetstagareService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public getBeslut(instance: string): Observable<Beslut[]> {
    return this.http.get<Beslut[]>(`${this.apiUrl}${instance}/beslut/get`);
  }
}
